import React from "react"
import ActionableNotificationItem from "./actionableNotification"
import NonActionableNotificationItem from "./nonActionableNotification"

const NotificationItem = ({ notification }) => {
	// Use the actionable component if the notification indicates that an action is needed
	if (notification.notification_name.includes("Approval Needed")) {
		return <ActionableNotificationItem notification={notification} />
	} else {
		return <NonActionableNotificationItem notification={notification} />
	}
}

export default NotificationItem
